import { ReactElement, ReactNode } from 'react';
import NavBar from '@components/NavBar';
import Footer from '@components/Footer';
import clsx from 'clsx';
import useNetworkEnv from '@hooks/useNetworkEnv';
import MainnetBackground from './Background/MainnetBackground';
import TestnetBackground from './Background/TestnetBackground';

interface MainLayoutProps {
  children: ReactNode;
  variant?: 'page' | 'popup';
}

function MainLayout({
  children,
  variant = 'page',
}: MainLayoutProps): ReactElement {
  const [isTestnet] = useNetworkEnv();

  return (
    <div className="min-h-screen flex flex-col">
      <div className="fixed top-0 bg-dark overflow-hidden h-screen w-screen -z-1 flex items-center justify-center">
        {isTestnet ? <TestnetBackground /> : <MainnetBackground />}
      </div>
      <div className="fixed h-screen w-screen bg-dark opacity-80 -z-1" />
      <NavBar />
      <main
        className={clsx('flex-1 flex flex-col', {
          'justify-start tablet:justify-center': variant === 'page',
          'justify-center': variant === 'popup',
        })}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default MainLayout;
